<div class="modal-header">
  <h4 class="modal-title">Temporarily Unavailable</h4>
</div>

<div class="modal-body">
  <div class="alert alert-warning mt-3" role="alert">
    Capitan is temporarily unavailable while brief maintenance completes.
    This usually clears within a few minutes.
  </div>

  <p class="mb-0 text-muted">
    <span *ngIf="lastCheckFailed">Still unavailable.</span>
    This page will reconnect on its own as soon as Capitan is back &mdash;
    there's no need to reload.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary"
          (click)="handleRetry()"
          [class.disabled]="checking"
          [disabled]="checking">
    {{ checking ? 'Checking...' : 'Retry' }}
  </button>
</div>
